import { CurrencyPipe, DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AnalyticsService } from '@app/global services';
import {
  EVENT_ACAO_GERENCIAMENTO,
  IContentEventApi
} from '@app/global services/analytics-services';
import {
  IPedidoEvento,
  IPedidos
} from '@app/modules/pedidos/model/pedidos.model';
import { Dialog } from 'primeng/dialog';

const ordemDataHora = (a: IPedidoEvento, b: IPedidoEvento) =>
  new Date(a.status_dh) < new Date(b.status_dh) ? 1 : -1;

@Component({
  selector: 'dialog-detalhes-pedido',
  templateUrl: './dialog-detalhes-pedido.component.html',
  styleUrls: ['./dialog-detalhes-pedido.component.scss']
})
export class DialogDetalhesPedidoComponent implements OnInit, AfterViewInit {
  @ViewChild('detalhesPedido') detalhesPedido: Dialog;
  pedido: IPedidos;
  eventoProducao: any;

  constructor(
    protected analyticsService: AnalyticsService,
    protected router: Router,
    public matDialog: MatDialog,
    public currencyPipe: CurrencyPipe,
    public datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: { pedido: IPedidos },
    public matDialogRef: MatDialogRef<DialogDetalhesPedidoComponent>
  ) {
    this.pedido = data.pedido;
    this.eventoProducao = data.pedido.eventos
      .sort(ordemDataHora)
      .filter(it => it.status === 'EM_ANDAMENTO')[0];
  }

  ngAfterViewInit() {
    this.detalhesPedido.maximize();
  }

  ngOnInit() {
    this.analyticsService.trackEventUseApi(EVENT_ACAO_GERENCIAMENTO, {
      conteudo: JSON.stringify(this.data.pedido),
      origem: `DETALHES DO PEDIDO - ${this.router.url}`
    } as IContentEventApi);
  }

  getPedidosRelacionados() {
    return this.pedido.pedidos_relacionados &&
      this.pedido.pedidos_relacionados.length !== 0
      ? this.pedido.pedidos_relacionados.join(',')
      : 'Não há pedidos relacionados';
  }
}
